/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste 2 or 3 columns of items (with a header row of set names) to draw the diagram.`)
};

const es_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega 2 o 3 columnas de elementos (con una fila de encabezado con los nombres de los conjuntos) para dibujar el diagrama.`)
};

const de_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge 2 oder 3 Spalten mit Elementen ein (mit einer Kopfzeile mit Mengennamen), um das Diagramm zu zeichnen.`)
};

const nl_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak 2 of 3 kolommen met items (met een koprij van setnamen) om het diagram te tekenen.`)
};

const fr_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez 2 ou 3 colonnes d'éléments (avec une ligne d'en-tête de noms d'ensembles) pour tracer le diagramme.`)
};

const it_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla 2 o 3 colonne di elementi (con una riga di intestazione con i nomi degli insiemi) per disegnare il diagramma.`)
};

const pt_br2_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole 2 ou 3 colunas de itens (com uma linha de cabeçalho com os nomes dos conjuntos) para desenhar o diagrama.`)
};

const pt_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole 2 ou 3 colunas de itens (com uma linha de cabeçalho com os nomes dos conjuntos) para desenhar o diagrama.`)
};

const ja_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`図を描画するには、2列または3列の項目(集合名のヘッダー行付き)を貼り付けてください。`)
};

const zh_venn_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 2 或 3 列项目（带有集合名称的表头行）即可绘制该图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_hint", locale)
	if (locale === "en") return en_venn_hint(inputs)
	if (locale === "es") return es_venn_hint(inputs)
	if (locale === "de") return de_venn_hint(inputs)
	if (locale === "nl") return nl_venn_hint(inputs)
	if (locale === "fr") return fr_venn_hint(inputs)
	if (locale === "it") return it_venn_hint(inputs)
	if (locale === "pt-BR") return pt_br2_venn_hint(inputs)
	if (locale === "pt") return pt_venn_hint(inputs)
	if (locale === "ja") return ja_venn_hint(inputs)
	return zh_venn_hint(inputs)
};